import { OrgChart } from '../components/OrgChart';

export function OrganizationPage() {
  return <OrgChart />;
}
